import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').controller('InvoiceItemEditCtrl', ['$scope', '$window', '$timeout', '$stateParams', '$state', 'leanLawApi', 'invoiceEditorService', 'codeService', function ($scope, $window, $timeout, $stateParams, $state, leanLawApi, invoiceEditorService, codeService) {
  // This is called from both invoice.create and from invoice.edit. So there is some hacking going on here to make it
  // work for both.
  // - .creates operates on items that are managed in invoiceEditorService
  // - .edit operates on an item passed in on $stateParmas.

  $scope.error = null;
  $scope.hoursUpdated = function () {
    $scope.update.amount = calculateEntryAmount($scope.update.rate.amount, $scope.update.hours);
  };
  $scope.amountUpdated = function () {
    if ($scope.update.fixed && $scope.update.rate && $scope.update.rate.amount) {
      $scope.update.rate.amount = $scope.update.amount;
    } else if ($scope.update.rate) {
      $scope.update.rate.amount = Math.round($scope.update.amount / $scope.update.hours * 100) / 100;
      $scope.update.rate.label = null;
      $scope.selectedRate = null;
    }
  };
  $scope.computedAmountUpdated = function () {
    // console.log("cau", $scope.update.amount);
    const total = $scope.item.amount / $scope.item.computed.settings.services * 100;
    // Calculate new percentage
    $scope.update.computed.settings.services = $scope.update.amount / total * 100;
    // Update description with servicelabel
    const sl = $scope.item.computed.settings.serviceLabel;
    $scope.update.description = sl.replace(/\%/, `${round2($scope.update.computed.settings.services)}%`);
  };
  $scope.percentageUpdated = function () {
    // Update description with servicelabel
    const sl = $scope.item.computed.settings.serviceLabel;
    $scope.update.description = sl.replace(/\%/, `${round2($scope.update.computed.settings.services)}%`);
    // Calculate total from what we know, then update displayed amount
    // This might show an incorrect amount in the field because of
    // rounding errors from limited information but will be correct upon save
    const total = $scope.item.amount / $scope.item.computed.settings.services * 100;
    $scope.update.amount = round2(total * (0.01 * $scope.update.computed.settings.services));
  };
  $scope.rateSelected = function (rate) {
    $scope.update.rate = rate ? angular.copy(rate) : {
      amount: 0
    };
    $scope.update.amount = calculateEntryAmount($scope.update.rate.amount, $scope.update.hours);
  };
  $scope.rateUpdated = function () {
    $scope.update.amount = calculateEntryAmount($scope.update.rate.amount, $scope.update.hours);
    $scope.update.rate.label = null;
    $scope.selectedRate = null;
  };
  $scope.save = function () {
    if ($scope.update.description.length > 4000) {
      bootbox.confirm('The description exceeds 4000 characters which is the maximum allowed by QuickBooks. Click OK to shorten description automatically or Cancel to edit', result => {
        if (result) {
          $scope.update.description = $scope.update.description.substring(0, 4000);
          save();
        }
      });
      return;
    }
    save();
  };
  activate();

  ///////////

  function activate() {
    $scope.codes = {};
    codeService.activityCodes().then(activity => {
      $scope.codes.activity = activity;
    });
    codeService.taskCodes().then(task => {
      $scope.codes.task = task;
    });
    if ($stateParams.item) {
      $scope.item = $stateParams.item;
    } else if (invoiceEditorService.state.invoice) {
      const group = invoiceEditorService.state.invoice.groups[$stateParams.groupIndex];
      $scope.item = group ? group.lineItems[$stateParams.itemIndex] : null;
    } else {
      $state.go('^');
    }
    $scope.isComputed = $scope.item.hasOwnProperty('computed');
    if (!$scope.item) {
      console.log('item required');
      return $state.go('^');
    }
    $scope.update = angular.copy($scope.item);
    if ($stateParams.focus) {
      $timeout(() => {
        const element = $window.document.getElementById(`input-${$stateParams.focus}`);
        if (element) {
          element.focus();
        }
      }, 0);
    }

    // Set some helpers on what to show and not show on form
    $scope.isEntry = !!$scope.item.entries;
    $scope.isExpense = !!$scope.item.expenses;
    $scope.showRateAndHours = $scope.isEntry && !$scope.item.fixed;
    if ($scope.isEntry) {
      const accounts = _.groupBy($scope.item.entries, e => e.account ? e.account.id : null);
      $scope.showRatePicker = _.size(accounts) == 1 && !accounts.null;
    }
    $scope.ledes = $stateParams.ledes;
    $scope.formHeight = 440 + ($scope.ledes ? 80 : 0) + ($scope.showRateAndHours ? 80 : 0);

    // Load lists for rate picks and accounting services
    leanLawApi.listAccountingServices().then(list => {
      $scope.services = list.services;
      if ($scope.update.accountingService) {
        $scope.update.accountingService = _.find($scope.services, s => s.id == $scope.update.accountingService.id);
      }
    });
    if ($scope.showRatePicker && $scope.item.entries.length) {
      $scope.account = $scope.item.entries[0].account;
      leanLawApi.getAccount({
        id: $scope.account.id
      }).then(account => {
        $scope.rates = account.rates.other || [];
        if (account.rates.standard) {
          $scope.rates.unshift({
            label: 'Standard',
            amount: account.rates.standard
          });
        }
        $scope.selectedRate = _.find($scope.rates, rate => rate.label == $scope.item.rate.label);
      });
    }
  }
  function round2(n) {
    return Math.round(n * 100) / 100;
  }
  function save() {
    console.log('Saving', $scope.item);
    if ($scope.item.update) {
      $scope.item.update($scope.update);
    } else {
      console.log('sssss', $scope);
      $scope.saveItem($scope.item, $scope.update);
    }
    $state.go('^');
  }
}]);